import TrackingSourceForm from './_form'
import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    TrackingSourceForm
  },
  data() {
    return {
      lastPath: null,
      lastPathParams: {},
      errors: {},
      utmErrors: {}
    }
  },
  beforeRouteEnter(_to, from, next) {
    // se añade el nombre de la ultima dirección, ya que, el boton cancelar debe redirigir
    // a la ultima dirección si esta es el listado de operadores o la creación de operadores
    next(vm => {
      if (['operators-index', 'operators-new', 'operators-edit'].includes(from?.name)) {
        vm.lastPathParams = from.params
        vm.lastPath = from.name
      }
    })
  },
  created() {
    this.$setPageTitle(this.$t('trackingSources.new.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.trackingSources.index'), route: {name: 'trackingSources-index'}},
      {label: this.$t('breadcrumbs.trackingSources.new'), route: {}}
    ])
  },
  methods: {
    createTrackingSource(data) {
      API.trackingSources.create(data).then(() => {
        this.$notifications.success(this.$t('trackingSources.new.succesfullyCreated'))

        this.$router.push({
          name: this.lastPath || 'tracking-sources-index',
          params: this.lastPathParams
        })
      }, errors => {
        this.errors = errors
      })
    }
  }
})
